import { Donor, DonorFromJSON } from '@/api'
import * as runtime from '../runtime'

export class DonorApi extends runtime.BaseAPI {
  /**
   * 寄贈者を取得する
   * 寄贈者取得
   */
  async getDonor(): Promise<Donor[]> {
    const response = await this.requestGet('/donors')

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(DonorFromJSON)
    ).value()
  }
}
